import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';

// Icons
import bellIcon from '../../images/alerta-icon.png';
import bellIconFilled from '../../images/alerta-icon-filled.png';
import classificationIcon from '../../images/classificacao.png';
import userIcon from '../../images/perfil.png';

class BottomNavigation extends Component {
    renderBarPercentage (percentage) {
        if (percentage > 100) {
            percentage = 0;
        }
        return (
            <div className='dashboard-progress'>
                <div className='progress-bar' style={{ width: `${percentage || 0}%` }} />
                <span className='progress-label'>{percentage || 0}%</span>
            </div>
        );
    }

    render () {
        const user = this.props.user;
        const canNavigate = !!user.data.level && typeof user.data.level !== 'string';
        return (
            <div className='bottomNavigation'>
                <nav className='nav'>
                    <div>
                        <Link to={canNavigate ? '/user' : '/'}>
                            <img src={userIcon} alt='Perfil' />
                        </Link>
                    </div>
                    <div>
                        <Link to={canNavigate ? '/ranking' : '/'}>
                            <img src={classificationIcon} alt='Ranking' />
                        </Link>
                    </div>
                    <div>
                        <div className='progressWrapper'>
                            <div className='text'>
                                <span>{(user.data.level) ? user.data.level.title : 'Nível'}</span>
                                <span>{user.data.points}</span>
                            </div>
                            <div className='progress'>
                                {this.renderBarPercentage(this.props.whatsNext ? this.props.whatsNext.percentAnsweredOnLevel : 0)}
                            </div>
                        </div>
                    </div>
                    <div>
                        <Link to={'/notifications'}>
                            {(this.props.newMessages > 0)
                                ? <img src={bellIconFilled} className='tada' alt='Notificações' />
                                : <img src={bellIcon} alt='Notificações' />
                            }
                        </Link>
                    </div>
                </nav>
            </div>
        );
    }
}

const mapStateToProps = (state) => ({
    user: state.user.user,
    newMessages: state.dashboardReducer.newMessages,
    whatsNext: state.user.whatsNext
});

export default connect(mapStateToProps)(BottomNavigation);



// WEBPACK FOOTER //
// ./src/views/DashboardViews/bottomNavigation.js